import { memo } from 'react';

import { MEMBER_STATUS } from '../../constants/copy';
import MemberAvatar from '../shared/MemberAvatar';
import StatusBadge from '../shared/StatusBadge';

/**
 * Name cell of the Members table: avatar (coloured initials; a generic placeholder, no initials, until the person has
 * signed in), name with the status badge next to it (Active shows no
 * badge, like the prototype) and the email underneath.
 */
function MemberNameCell({ member, isNew = false }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <MemberAvatar member={member} size="lg" />
      <div className="flex min-w-0 flex-col">
        <span className="flex min-w-0 items-center gap-2">
          <span className="truncate text-sm font-medium text-content">{member.displayName}</span>
          {member.status !== MEMBER_STATUS.ACTIVE || isNew ? (
            <StatusBadge
              status={member.status}
              isNew={isNew}
              showStatus={member.status !== MEMBER_STATUS.ACTIVE}
            />
          ) : null}
        </span>
        <span className="truncate text-xs text-content-muted">{member.email}</span>
      </div>
    </div>
  );
}

export default memo(MemberNameCell);
